import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { get } from 'lodash';
import { Alert, Button, Col, Container, RadioButton, Row, HeadingText, BodyText, Link } from '@paypalcorp/pp-react';
import GetStartedHero from './GetStartedHero';
import PPHeader from '../../../common/components/PPHeader';
import { parseMessages } from '../../../utilityHelper';
import { AUTO_ENROLL_COUNTRIES } from '../../../../../constants/constants';
import { TECHSOUP_SUPPORTED_COUNTRIES } from '../../../../../constants/constants_ppcc';
import * as FPT from '../../../utility/fpt';
import { COUNTRY_CONFIG } from '../../../../../constants/CountryConfig';
import * as linksURL from '../../../../../constants/links.json';
import { getCdnHostName } from '@paypalcorp/instance-location';
import { bindFPTIClicks } from '../../../common/domUtils'
import PPFooter from '../../../common/components/PPFooter';
import GivingHeader from '../../../common/components/GivingHeader';
import withTheme from '../../../common/withTheme';
import { PPCC_BENEFITS_HEADERFOOTER } from '../../../../../constants/constants';

let templateData = {};
try {
    templateData.ratesResult = JSON.parse(document.getElementById('data-rates-result') && document.getElementById('data-rates-result').innerHTML || '{}');
    templateData.country = document.getElementById('data-country') && document.getElementById('data-country').innerHTML || '',
    templateData.ppccData = document.getElementById('data-ppccData') && document.getElementById('data-ppccData').innerHTML || '{}';
} catch (e) {
    console.warn('Error while parsing data', e);
}
const countryCode = templateData.country;
const propertyInfo = parseMessages('ppcc/confirmation/confirmation-home'),
    ratesResult = templateData.ratesResult,
    noFeeDiscount = get(COUNTRY_CONFIG, [countryCode, 'noFeeDiscount'], false),
    ppgfContact = get(linksURL, 'links[countryCode].ppgfContact', ''),
    ppccData = JSON.parse(templateData.ppccData),
    ppccHeroPage = get(COUNTRY_CONFIG, [countryCode, 'ppccHeroPage'], false),
    propertyInfoPPCC = parseMessages('ppcc/dashboardppcc/dashboard');

let ppccTxnRate = ratesResult ? (`${ratesResult.ppccTxnRate_percent} + ${ratesResult.ppccCharityRate}`) : '';
const benefitsHeaderFooter = PPCC_BENEFITS_HEADERFOOTER.includes(countryCode);
const noFundraisingPlatform = (get(COUNTRY_CONFIG, [countryCode, 'charityDashboard']) && get(COUNTRY_CONFIG, [countryCode, 'noFundraisingPlatform']));
class GetStarted extends React.Component {
    componentDidMount() {
        FPT.trackPageWithData('main:givingfund:ppcc:getstarted', { event_name: 'ppcc_getstarted_shown', product: 'ppcc' });
        bindFPTIClicks({ product: 'ppcc' });
    }
    render() {

        const getStartedList1 = (propertyInfo && propertyInfo.getStarted.li1) ? propertyInfo.getStarted.li1.replace('{ppccTxnRate}', ppccTxnRate) : '';
        const getStartedList2 = get(COUNTRY_CONFIG, [countryCode.toUpperCase(), 'directModel']) ? propertyInfo.getStarted.DMli2 : propertyInfo.getStarted.li2;
        const getStartedList3 = (propertyInfo && propertyInfo.getStarted.li3) ? propertyInfo.getStarted.li3.replace('{ppgfContact}', ppgfContact) : '';
        const buttonText = noFundraisingPlatform ? propertyInfo.ppcc.confirmbtn : (noFeeDiscount ? propertyInfo.getStarted.noDiscountFee.continue : propertyInfo.getStarted.continue);
        const isAutoEnrolled = AUTO_ENROLL_COUNTRIES.includes(countryCode);
        return (
            <>
                <PPHeader ppccHeroPageHeader={benefitsHeaderFooter} />
                <div id="getStarted">
                    {ppccHeroPage ?
                        <GetStartedHero ppccTxnRate={ppccTxnRate} grantSection={ppccData.grantSection} venmoSection={ppccData.venmoSection} countryCode={countryCode} />
                        :
                        <>
                            <GivingHeader confirmationFlow={true} />
                            <Container style={{ margin: '5rem auto 0 auto', maxWidth: '50rem' }}>

                                {noFundraisingPlatform ?
                                    <Row>
                                        <Col style={{ textAlign: 'center' }}>
                                            <img src={`https://${getCdnHostName()}/paypal-ui/pictograms/blue/svg/quick-start-blue.svg`} alt="" width='120' />
                                            <HeadingText size="lg">{propertyInfo.getStarted.donation.title}</HeadingText>
                                            <BodyText style={{ margin: '1.5rem 0' }}>{propertyInfo.getStarted.donation.description}</BodyText>
                                        </Col>
                                    </Row>
                                    :
                                    <Row>
                                        <Col>
                                            <div style={{ textAlign: 'center' }}>
                                                <img src={`https://${getCdnHostName()}/paypal-ui/pictograms/blue/svg/quick-start-blue.svg`} alt="" width='120' />
                                            </div>
                                            <HeadingText size="lg">{noFeeDiscount ? propertyInfo.getStarted.noDiscountFee.h3 : propertyInfo.getStarted.h3}</HeadingText>
                                            <BodyText style={{ margin: '1.5rem 0' }}>
                                                {noFeeDiscount ? propertyInfo.getStarted.noDiscountFee.p : propertyInfo.getStarted.p}
                                            </BodyText>
                                            {!noFeeDiscount &&
                                                <BodyText>
                                                    <ul>
                                                        <li>{getStartedList1}</li>
                                                        <li>{ReactHtmlParser(getStartedList2)}</li>
                                                        {isAutoEnrolled && <li>{ReactHtmlParser(getStartedList3)}</li>}
                                                    </ul>
                                                </BodyText>
                                            }
                                        </Col>
                                    </Row>
                                }
                                <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
                                    <Button data-fpti="getStartedContinueBtn" as="a" href="/charities/dashboard" id="confirmAccount">{buttonText}</Button>
                                </div>
                            </Container>
                        </>
                    }
                </div>
                <PPFooter />
            </>
        );
    }
}



class InProgressCharity extends React.Component {
    componentDidMount() {
        FPT.trackPage('main:givingfund:ppcc:dashboard:inprogress');
    }
    render() {
        return (
            <>
                <GivingHeader confirmationFlow={true} />
                <Container id="ConfirmCharityWapper" style={{ textAlign: 'center' }}>
                    <Row>
                        <Col style={{ textAlign: 'center' }}>
                            <img src={`https://${getCdnHostName()}/paypal-ui/pictograms/multicolored/svg/email.svg`} width="150" alt="" />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <HeadingText size='sm' style={{ marginBottom: '20px' }}>{propertyInfo.inprogress.title}</HeadingText>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <BodyText style={{ marginBottom: '20px' }} className="successmessage">{propertyInfo.inprogress.message}</BodyText>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button style={{ marginBottom: '20px' }} data-fpti="inProgressContinueBtn" as="a" href="/" type="primary" className="continueBtn">{propertyInfo.success.continuemsg}</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Link data-fpti="inProgressContactusBtn" href="/smarthelp/contact-us">{propertyInfo.reach.contact}</Link>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

class SomethingWentWrongCharity extends React.Component {
    componentDidMount() {
        FPT.trackPage('main:givingfund:ppcc:dashboard:somethingwentwrong');
    }
    render() {
        return (
            <>
                <GivingHeader confirmationFlow={true} />
                <Container id="ConfirmCharityWapper" style={{ textAlign: 'center' }}>
                    <Row>
                        <Col style={{ textAlign: 'center' }}>
                            <img width="120" src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-critical.svg"></img>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <HeadingText size="sm">{propertyInfo.somethingwentwrong.message1}</HeadingText>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <BodyText>{propertyInfo.somethingwentwrong.message2}</BodyText>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

class InValidPPCCharityType extends React.Component {
    componentDidMount() {
        FPT.trackPage('main:givingfund:ppcc:dashboard:invalidcharitytype');
    }
    render() {
        let countryCode = this.props.countryCode;
        return (
            <>
                <GivingHeader confirmationFlow={true} />
                <Container id="ConfirmCharityWapper" style={{ textAlign: 'center' }}>
                    <Row>
                        <Col>
                            <img width="120" src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-warning.svg" alt="" />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <HeadingText style={{ marginBottom: '24px' }} size="sm">{propertyInfo.craWarning.title}</HeadingText>
                        </Col>
                    </Row>
                    {countryCode === 'CA' ? (
                        <>
                            <Row>
                                <Col>
                                    <BodyText style={{ marginBottom: '52px' }}>{propertyInfo.craWarning.bodytext}</BodyText>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button data-fpti="nonCraContinueBtn" as="a" href={this.props.profileLink} type="primary" className="continueBtn">{propertyInfo.craWarning.profileLink}</Button>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: '24px' }}>
                                <Col><Link data-fpti="nonCraAccountBtn" href="/">{propertyInfo.craWarning.accontBtn}</Link></Col>
                            </Row>
                        </>
                    ) :
                        (
                            <Row>
                                <Col>
                                    <BodyText>{propertyInfo.charityStaus.errMsg}</BodyText>
                                </Col>
                            </Row>
                        )}



                </Container>
            </>
        );
    }
}

class RevokedCharity extends React.Component {
    componentDidMount() {
        FPT.trackPage('main:givingfund:ppcc:dashboard:revoked');
    }
    render() {
        const techsoupCountries = (TECHSOUP_SUPPORTED_COUNTRIES.includes(countryCode) || get(COUNTRY_CONFIG, [countryCode, 'techsoup']));
        let propertyObj = { title: propertyInfo.revoked.title, btnLabel: propertyInfoPPCC.contactcustomerservice };
        if (templateData.country === 'US') {
            propertyObj.title = propertyInfoPPCC.Error_Title;
            propertyObj.desc = propertyInfoPPCC.Error_Title_desc;
        } else if (techsoupCountries) {
            propertyObj.desc = propertyInfo.revoked.message;
        }
        return (
            <>
                <GivingHeader confirmationFlow={true} />
                <Container id="ConfirmCharityWapper" style={{ textAlign: 'center' }}>
                    <Row>
                        <Col>
                            <img width="120" src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-warning.svg"></img>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <HeadingText size='sm'>{propertyObj.title}</HeadingText>
                        </Col>
                    </Row>
                    {propertyObj.desc &&
                        <Row>
                            <Col>
                                <BodyText style={{ marginTop: '1.5rem' }} className="successmessage">{ReactHtmlParser(propertyObj.desc)}</BodyText>
                            </Col>
                        </Row>
                    }
                    {propertyObj.btnLabel && <Row>
                        <Col>
                            <Button style={{ marginTop: '1.5rem' }} data-fpti="contactus" as="a" href="/smarthelp/contact-us" type="primary">{propertyObj.btnLabel}</Button>
                        </Col>
                    </Row>
                    }
                </Container>
            </>
        );
    }
}

class ChooseCharityTypes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            charityType: ''
        }
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(ev) {
        this.setState({
            charityType: ev.target.value
        })
        this.props.handleChange(ev);
    }
    componentDidMount() {
        FPT.trackPage('main:givingfund:ppcc:dashboard:choosecharitytype');
    }
    render() {
        let countryCode = this.props.countryCode;

        return (
            <>
                <GivingHeader confirmationFlow={true} />
                <Container id="ConfirmCharityWapper">
                    <Row>
                        <Col>
                            <HeadingText style={{ marginBottom: '30px' }} size="sm">{propertyInfo.chooseCT.headline1}</HeadingText>
                            <Alert className="errorMsg" type="error">{propertyInfo.chooseCT.errMsg}</Alert>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {countryCode === 'BR' &&
                                <div>
                                    <RadioButton
                                        name="charityType"
                                        className="charityType"
                                        label={propertyInfo.chooseCT.headline2}
                                        onChange={this.handleChange}
                                        value={this.state.charityType}
                                        options={[
                                            { label: propertyInfo.chooseCT.type.br1, value: 'BR_CEBAS' },
                                            { label: propertyInfo.chooseCT.type.br2, value: 'BR_OS' },
                                            { label: propertyInfo.chooseCT.type.br3, value: 'BR_OSCIP' },
                                            { label: propertyInfo.chooseCT.type.br4, value: 'BR_UPF' },
                                            { label: propertyInfo.chooseCT.type.br5, value: 'BR_OTHER' },
                                        ]}
                                    />
                                </div>
                            }
                            {countryCode === 'MX' &&
                                <div>
                                    <RadioButton
                                        name="charityType"
                                        className="charityType"
                                        label={propertyInfo.chooseCT.headline2}
                                        onClick={this.handleChange}
                                        options={[
                                            { label: propertyInfo.chooseCT.type.mx1, value: 'MX_OSC' },
                                            { label: propertyInfo.chooseCT.type.mx2, value: 'MX_SAT' },
                                            { label: propertyInfo.chooseCT.type.mx3, value: 'MX_OTHER' },
                                        ]}
                                    />
                                </div>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{ textAlign: 'center' }}>
                            <Button onClick={this.props.submitCharityType} className="continueBtn">{propertyInfo.chooseCT.continuemsg}</Button>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

export const GetStartedPPCC = withTheme(GetStarted);
export const Inprogress = withTheme(InProgressCharity);
export const ChooseCharityType = withTheme(ChooseCharityTypes);
export const InValidCharityType = withTheme(InValidPPCCharityType);
export const SomethingWentWrong = withTheme(SomethingWentWrongCharity);
export const Revoked = withTheme(RevokedCharity);